import classNames from 'classnames'
import styles from './ChoosePayment.module.scss'

const ChoosePayment = () => {
    return (
        <section className="u-paddingVertical--4xl">
            <div className="container">
                <div className="row row--center-xs">
                    <div className="col col--xs-8 u-marginAuto">
                        <div className={styles.text}>
                        *Your rate will be 0% -30% APR based on credit and is subject to an eligibility check. For example, a $700 purchase might cost $64/mo over 12 months at 15% APR. Payment options through Affirm are provided by these lending partners: <a href='https://www.affirm.com/lenders'>affirm.com/lenders.</a> Options depend on your purchase amount, and a down payment may be required.
                        </div>
                    </div>
                    <div className="u-paddingTop--xl col col--xs-12 col--lg-10 u-flexAlign--center">
                        <h2 className="t-heading2">Choose 6, 12, or 18 monthly payments</h2>
                    </div>
                    <div className={classNames('col col--xs-12 col--lg-10 u-flexAlign--center', styles.image)} />
                </div>
            </div>
        </section>
    )
}

export default ChoosePayment
